import styled, { css } from 'styled-components';
import { BUTTON_VARIANTS, COLOURS, FLAIR_COLOURS } from '@belong/themes';
import { isFlairColor } from '@belong/themes/helpers/value';
import { IMoleculeNavLinkGroup } from '@belong/types';
import { Button, Heading } from '@belong/ui-components';

export const LinkPanelHeading = styled(Heading).attrs({ variant: 'large', as: 'h2' })`
  color: ${COLOURS.WHITE};
  padding: 0 2rem;
`;

export const SummaryButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.TERTIARY,
  isLightColor: true
})`
  margin: 0 3rem;
  padding: 0 0 1.2rem 0;
`;

interface ILinkGroupHeading {
  headingColor: IMoleculeNavLinkGroup['labelColour'];
}
export const LinkGroupHeading = styled(Heading).attrs({ variant: 'medium', as: 'h3' })<ILinkGroupHeading>`
  ${({ headingColor }) => {
    if (isFlairColor(headingColor)) {
      return css`
        background-image: ${FLAIR_COLOURS[headingColor]};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: initial;
      `;
    }

    return css`
      color: ${COLOURS[headingColor]};
    `;
  }};

  font-weight: 600;
  padding: 0 2rem;
`;

export const LinkGroup = styled.ul`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }

  li a {
    height: 5rem;
    min-height: 5rem;
  }
`;
